import React from "react"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

type TSidebarProps = {
  categories: string[]
  value?: string
  onSelect?: (category: string) => void
}

const SidebarCategoryItem: React.FC<{
  id: string
  text: string
  isSelected: boolean
  onClick?: (id: string) => void
}> = ({ id, text, isSelected, onClick }) => {
  const handleSelect = () => {
    onClick?.(id)
  }

  return (
    <li
      className={cn(
        "py-3 px-4 cursor-pointer border-l-[1px] border-l-system-blue-600 text-left",
        "font-lato text-base font-medium leading-[135%] tracking-[-0.01rem]",
        "transition-all duration-300 ease-in-out",
        "hover:transition-colors hover:duration-200",
        isSelected
          ? " border-l-[#EE8EB9] bg-[rgba(238,142,185,0.10)] text-white"
          : "text-system-gray-400 hover:bg-[rgba(238,142,185,0.10)] hover:text-white",
      )}
      onClick={handleSelect}
    >
      {text}
    </li>
  )
}

const Sidebar: React.FC<TSidebarProps> = ({ categories, value, onSelect }) => {
  const selectedCategory = value || categories[0]

  const handleSelectCategory = (category: string) => {
    onSelect?.(category)
  }

  return (
    <div className="w-64 min-w-64 p-6 h-full overflow-y-auto md:block hidden lg:w-64 lg:min-w-64">
      <h3 className="text-lg font-semibold text-gray-900 text-left mb-6">
        Page Content
      </h3>
      <nav>
        <ul className="">
          {categories.map(category => (
            <SidebarCategoryItem
              id={category}
              key={category}
              text={category}
              isSelected={selectedCategory === category}
              onClick={handleSelectCategory}
            />
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default Sidebar
